// extracted by mini-css-extract-plugin
export default {"form":"CardUpdatePage_form__68RL4","button":"CardUpdatePage_button__imh78","card":"CardUpdatePage_card__zQuWv","wrapper":"CardUpdatePage_wrapper__68GQu"};